module.exports = __webpack_public_path__ + "static/img/treatTrue.c2351156.png";